import { ref, computed } from '@vue/composition-api';
import { getInHospitalDoctorGroupList, getInHospitalTagList } from '@/services/user/index';
export default () => {
  const doctorGroupOptions = ref<any>([]);
  const doctorGroupId = ref<any>([]);
  const tagOptions = ref<any>([]);
  const tagId = ref<any>([]);

  // 获取科室列表
  const getDoctorGroup = async () => {
    const { doctorGroupList } = await getInHospitalDoctorGroupList();
    doctorGroupOptions.value = doctorGroupList;
    doctorGroupId.value = doctorGroupOptions.value.map(item => item.id);
  };
  const getTag = async () => {
    const { tagList } = await getInHospitalTagList();
    tagOptions.value = tagList;
    tagId.value = tagOptions.value.map(item => item.id);
  };
  const doctorGroupMultipleSelect = async (list: string[]) => {
    doctorGroupId.value = list;
  };
  const tagMultipleSelect = async (list: string[]) => {
    tagId.value = list;
  };
  const computedDoctorGroupId = computed(() => {
    if (doctorGroupId.value.length === 0) {
      return '';
    }
    return doctorGroupId.value.includes('') ? '' : doctorGroupId.value.join(',');
  });
  const computedTagId = computed(() => {
    if (tagId.value.length === 0) {
      return '';
    }
    return tagId.value.includes('') ? '' : tagId.value.join(',');
  });
  return {
    getDoctorGroup,
    getTag,
    doctorGroupOptions,
    tagOptions,
    doctorGroupId,
    tagId,
    computedDoctorGroupId,
    computedTagId,
    tagMultipleSelect,
    doctorGroupMultipleSelect,
  };
};
